import { Expose } from 'class-transformer';

import { SnModel } from '@lib/common/models';

export class ContentType extends SnModel {
  @Expose()
  public id: number;

  @Expose()
  public appLabel: string;

  @Expose()
  public model: string;

  constructor(data: any = {}) {
    super();
    this.fromJSON(data);
  }
}
